import { useMutation, useQuery, useQueryClient } from "react-query";
import axiosConfig from "../config/axios";

export const fetchLocations = async ({ queryKey }) => {
  const [_key, searchValue, searchCategory, pageNumber, ITEMS_PER_PAGE] =
    queryKey;
  try {
    const params = searchValue
      ? {
          nameEnglish: searchValue,
          nameLatin: searchValue,
          nameCyrillic: searchValue,
          pageNumber: 1,
          pageSize: 20000,
          intersectionColumns: "Categories",
          unionColumns: "NameEnglish,NameLatin,NameCyrillic",
        }
      : {
          nameEnglish: searchValue,
          nameLatin: searchValue,
          nameCyrillic: searchValue,
          pageNumber,
          pageSize: ITEMS_PER_PAGE,
          intersectionColumns: "Categories",
          unionColumns: "NameEnglish,NameLatin,NameCyrillic",
        };

    if (searchCategory !== "") {
      params.categories = searchCategory;
    }

    const { data } = await axiosConfig.get("/admin/locations", {
      params,
    });

    return data;
  } catch (error) {
    console.error("Error while fetching locations", error);
  }
};

const removeLocation = async (id) => {
  await axiosConfig.delete(`/locations/${id}`);
};

export const useFetchLocationsData = (
  searchValue,
  searchCategory,
  pageNumber,
  ITEMS_PER_PAGE
) => {
  const {
    data: locations,
    isLoading,
    isError,
    refetch,
  } = useQuery(
    ["locations", searchValue, searchCategory, pageNumber, ITEMS_PER_PAGE],
    fetchLocations,
    {
      cacheTime: 3600000,
      keepPreviousData: true,
    }
  );
  return { locations, isLoading, isError, refetch };
};

export const useRemoveLocation = () => {
  const queryClient = useQueryClient();

  return useMutation(removeLocation, {
    onSuccess: () => {
      queryClient.invalidateQueries("locations");
    },
  });
};
